import { Modal } from 'antd'
import TipsyButton from 'Comps/ui-kit/TipsyButton'
import SearchIcon from '@/components/svg/SearchIcon'
import { CloseOutlinedIcon } from '@/components/svg'
import type { IdList, ProfileCharacterList } from '@/types/character'
import type { ISearchResultData } from '@/types/serach'

type StoryCharacterDrawerProps = {
  open: boolean
  onClose: () => void
  t: (key: string, replacements?: Record<string, string | number>) => string
  // userRoleName: string
  //renderUser: () => JSX.Element
  drawerIdList: IdList[]
  renderDrawerCharacter: (item: IdList) => JSX.Element
  searchText: string
  onSearchChange: (text: string) => void
  searchResults: ProfileCharacterList[]
  publicCharacterData: ProfileCharacterList[]
  renderDrawerListItem: (
    item: ProfileCharacterList | ISearchResultData,
    isPersonal: boolean
  ) => JSX.Element
  searchTotal: number
  searchLoading: boolean
  onLoadMore: () => void
  onConfirm: () => void
}

export default function StoryCharacterDrawer({
  open,
  onClose,
  t,
  // userRoleName,
  drawerIdList,
  renderDrawerCharacter,
  searchText,
  onSearchChange,
  searchResults,
  publicCharacterData,
  renderDrawerListItem,
  searchTotal,
  searchLoading,
  onLoadMore,
  onConfirm,
}: StoryCharacterDrawerProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      width={520}
      destroyOnClose
      closeIcon={
        <CloseOutlinedIcon size={18} color="#FFFFFF" strokeWidth={2} />
      }
      footer={null}
      style={{ maxWidth: 'calc(100vw - 32px)' }}
      styles={{
        content: {
          background:
            'linear-gradient(135deg, rgba(48, 50, 41, 0.95), rgba(61, 44, 41, 0.98))',
          border: '1px solid rgba(255,255,255,0.08)',
        },
        header: {
          background: 'transparent',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        },
        body: {
          background: 'transparent',
          height: 'calc(100vh - 180px)',
          overflow: 'hidden',
        },
      }}
      title={<div className="text-base text-white">{t('Add Characters')}</div>}
    >
      <div className="flex h-full min-h-0 flex-col gap-4">
        <div className="shrink-0">
          <div className="mb-2 text-sm text-white">
            {t('Character List')} ({drawerIdList.length || 0})
          </div>
          <div className="no-scrollbar flex items-start gap-4 overflow-x-auto overflow-y-hidden pb-2 pr-1">
            {/* 先暂时删除renderUser */}
            {/* {renderUser()} */}
            {drawerIdList.map((item) => renderDrawerCharacter(item))}
          </div>
        </div>
        <div className="shrink-0">
          <div className="mb-2 text-sm text-white">{t('Search')}</div>
          <div className="flex h-10 items-center rounded-full bg-white/5 px-3">
            <SearchIcon color="#B3B3B3" size={18} opacity={0.6} />
            <input
              type="text"
              value={searchText}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={t('Search')}
              className="ml-2 flex-1 bg-transparent text-sm text-white outline-none placeholder:text-white/30"
            />
            {searchText && (
              <button
                type="button"
                className="flex h-6 w-6 items-center justify-center"
                onClick={() => onSearchChange('')}
              >
                <CloseOutlinedIcon
                  size={18}
                  color="#B3B3B3"
                  strokeWidth={1.5}
                />
              </button>
            )}
          </div>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto pr-1">
          {searchText && searchResults.length > 0 ? (
            searchResults.map((item) => renderDrawerListItem(item, true))
          ) : !searchText && publicCharacterData.length > 0 ? (
            publicCharacterData.map((item) => renderDrawerListItem(item, true))
          ) : (
            <div className="py-6 text-center text-sm text-white/50">
              {t('No Results')}
            </div>
          )}
          {searchText && searchResults.length < searchTotal && (
            <div className="flex justify-center py-3">
              <TipsyButton
                className="h-9 w-[160px]"
                variant="filled"
                onClick={onLoadMore}
                loading={searchLoading}
              >
                {t('Load More')}
              </TipsyButton>
            </div>
          )}
        </div>
        <div className="flex shrink-0 gap-2 pt-2 text-white">
          <TipsyButton
            className="h-10 flex-1"
            variant="filled"
            onClick={onConfirm}
          >
            {t('Confirm')}
          </TipsyButton>
          <TipsyButton
            className="h-10 flex-1"
            variant="outlined"
            onClick={onClose}
          >
            {t('Cancel')}
          </TipsyButton>
        </div>
      </div>
    </Modal>
  )
}
